import React from 'react';
import './styles.spinner-loader.scss';

export const Spinner = () => (
  <div className="loader" data-testid="loader"></div>
);
